// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"d77b5014652d2608","6057":"d121ef6613edf08a"}[chunkId] + ".css";
};